module.exports = __webpack_public_path__ + "img/kefu.2b07d677.png";